module.exports = "<div class=c-hp-news-items-list> <a v-for=\"item in items\" class=c-hp-news-item tabindex=0 v-bind:href=item.link target=_blank> <div class=c-hp-news-item__date> {{ item.date }} </div> <div class=c-hp-news-item__text> {{ item.message }} <span class=c-hp-news-item__read-more> read more » </span>  </div> </a> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/frontend/pages/home/templates/news-items.html
// module id = 112
// module chunks = 4